export const Types = {
  CREATE_LOGISTIC_CENTER: 'logisticCenter/CREATE_LOGISTIC_CENTER',
  UPDATE_LOGISTIC_CENTER: 'logisticCenter/UPDATE_LOGISTIC_CENTER',
  SET_RESULTS: 'logisticCenter/SET_RESULTS',
  NEXT_RESULTS: 'logisticCenter/NEXT_RESULTS',
  SET_PAGE_INFO: 'logisticCenter/SET_PAGE_INFO',
  SET_ERROR_QUERY: 'logisticCenter/SET_ERROR_QUERY',
  SET_ERROR_MUTATION: 'logisticCenter/SET_ERROR_MUTATION',
  SET_SUCCESS_QUERY: 'logisticCenter/SET_SUCCESS_QUERY',
  SET_SUCCESS_MUTATION: 'logisticCenter/SET_SUCCESS_MUTATION',
  LOAD_QUERY: 'logisticCenter/LOAD_QUERY',
  LOAD_MUTATION: 'logisticCenter/LOAD_MUTATION',
  FETCH_LOGISTIC_CENTERS: 'logisticCenter/FETCH_LOGISTIC_CENTERS',
  RESET_STATE: 'logisticCenter/RESET_STATE',
  USER_LOGOUT: 'USER_LOGOUT',
};

const initialState = {
  results: [],
  pageInfo: {},
  load_query: false,
  load_mutation: false,
  error_query: {},
  error_mutation: {},
  success_query: {},
  success_mutation: {},
};

export default function logisticCenter(state = initialState, action) {
  switch (action.type) {
    case Types.SET_RESULTS:
      return { ...state, results: action.results };
    case Types.NEXT_RESULTS:
      return { ...state, results: [...state.results, ...action.results] };
    case Types.SET_PAGE_INFO:
      return { ...state, pageInfo: action.pageInfo };
    case Types.SET_ERROR_QUERY:
      return { ...state, error_query: action.error };
    case Types.SET_ERROR_MUTATION:
      return { ...state, error_mutation: action.error };
    case Types.SET_SUCCESS_QUERY:
      return { ...state, success_query: action.success };
    case Types.SET_SUCCESS_MUTATION:
      return { ...state, success_mutation: action.success };
    case Types.LOAD_QUERY:
      return { ...state, load_query: action.load };
    case Types.LOAD_MUTATION:
      return { ...state, load_mutation: action.load };
    case Types.RESET_STATE:
    case Types.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function saveLogisticCenter({ data, edit, success, error }) {
  return {
    type:
      edit === true
        ? Types.UPDATE_LOGISTIC_CENTER
        : Types.CREATE_LOGISTIC_CENTER,
    data,
    success,
    error,
  };
}

export function fetchLogisticCenters() {
  return {
    type: Types.FETCH_LOGISTIC_CENTERS,
  };
}

export function resetState() {
  return {
    type: Types.RESET_STATE,
  };
}
